import BaseMapper from '../../BaseMapper';

const EventCompetitorsMapper = (data, context) => {
    return data;
};

export default EventCompetitorsMapper;
